import * as React from "react"

import { cn } from "@/lib/utils"
import styles from './input.module.css'
import { Label } from '@/components/label/label'

export interface InputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size"> {
  size?: 'sm' | 'md' | 'lg'
  label?: string
  helperText?: string
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, size = 'md', label, helperText, id, ...props }, ref) => {
    const sizeClass =
      size === 'sm' ? styles.sizeSm : size === 'lg' ? styles.sizeLg : styles.sizeMd
    const reactId = React.useId()
    const controlId = id ?? `input-${reactId}`
    return (
      <div>
        {label ? (
          <Label
            htmlFor={controlId}
            size={size === 'sm' ? 'sm' : 'md'}
            className={styles.label}
          >
            {label}
            {/* Helper rides inline right after the label text (not under the
                input), muted. Inside the Label so it's announced with it; no
                typography class of its own, so it inherits the label's size
                and baseline. */}
            {helperText ? (
              <span className={styles.helper}>{helperText}</span>
            ) : null}
          </Label>
        ) : null}
        <input
          id={controlId}
          type={type}
          className={cn("body-md", styles.input, sizeClass, className)}
          ref={ref}
          {...props}
        />
        {/* No label to attach to — fall back to the old under-input line. */}
        {!label && helperText ? (
          <p className={cn("body-sm", styles.helper)}>
            {helperText}
          </p>
        ) : null}
      </div>
    )
  }
)
Input.displayName = "Input"

export { Input }
